// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"e71a0c91","481":"bbc2b135","548":"f92282aa","941":"d6a4aa68"}[chunkId] + ".chunk.css";
};